var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 42,
    viewBox: "0 0 54 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0.5C19.3535 0.5 12.5859 1.29102 8.46973 1.90625C5.10058 2.4043 2.41992 5.04102 1.80469 8.4248C1.27734 11.3838 0.75 15.7051 0.75 21.125C0.75 26.5449 1.27734 30.8662 1.80469 33.8252C2.41992 37.209 5.10058 39.8311 8.46973 40.3438C12.6006 40.959 19.3975 41.75 27 41.75C34.6025 41.75 41.3848 40.959 45.5156 40.3438H45.5303C48.8994 39.8457 51.5801 37.209 52.1953 33.8252C52.7227 30.8516 53.25 26.5303 53.25 21.125C53.25 15.7051 52.7227 11.3838 52.1807 8.4248C51.5801 5.04102 48.8994 2.4043 45.5303 1.90625C41.4141 1.29102 34.6465 0.5 27 0.5ZM27 4.25C34.3828 4.25 40.9893 5.01172 44.9736 5.6123C46.7314 5.87598 48.1523 7.25293 48.4893 9.08399C48.9873 11.8525 49.5 15.9541 49.5 21.125C49.5 26.2959 48.9873 30.3975 48.5039 33.1514C48.167 34.9971 46.7461 36.374 44.9736 36.6377C40.96 37.2236 34.3389 38 27 38C19.6611 38 13.0254 37.2236 9.02637 36.6377C7.26855 36.374 5.83301 34.9971 5.49609 33.1514C5.0127 30.3828 4.5 26.2959 4.5 21.125C4.5 15.9395 5.0127 11.8525 5.49609 9.08399C5.83301 7.25293 7.25391 5.87598 9.01172 5.62696H9.02637C13.0107 5.02637 19.6172 4.25 27 4.25ZM19.5 11.75V30.5L38.25 21.125L19.5 11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI11);
export default __webpack_public_path__ + "static/media/i11.315d75c176370f0b51861b7a1a0d93a3.svg";
export { ForwardRef as ReactComponent };